module.exports = __webpack_public_path__ + "static/media/bg-1-1.6b2b0135.jpg";